import { IPaginationUpdateAction, PaginationActionType } from ".";
import { IPagination } from "..";

/**
 * When items will be updated
 * 
 * @param items
 */
export const PaginationUpdatedAction = (pagination: IPagination): IPaginationUpdateAction => {
    return {
        type: PaginationActionType.UPDATE,
        pagination
    };
}